// extracted by mini-css-extract-plugin
module.exports = {"container":"CallerIDDisplay_container__LxZH0","textCycle":"CallerIDDisplay_textCycle__1HGKN"};